.App {
  display: flex;
  flex-direction: row;
  font-size: 1rem;
}

.SideNav {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.25rem;
  padding: 0;
}

.ButtonRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1ch;
}

.MainButton,
.UserButton {
  font-size: 1rem;
  outline: none;
  border: none;
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
}

.MainButton {
  background-color: var(--color-demo-button-background);
  color: var(--color-demo-button);
  text-align: left;
}
.MainButton:disabled {
  opacity: 0.5;
  cursor: default;
}
.MainButton:not(.MainButton:disabled):hover {
  background-color: var(--color-demo-button-background-hover);
}

.UserButton {
  background-color: transparent;
  color: var(--color-demo-button);
  margin-right: 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1ch;
  white-space: nowrap;
}
.UserButton:not(.UserButton[data-current]):hover {
  background-color: var(--color-demo-button-background-hover);
}
.UserButton[data-status="not-found"] svg {
  color: var(--color-status-not-found);
}
.UserButton[data-status="pending"] svg {
  color: var(--color-status-pending);
}
.UserButton[data-status="resolved"] svg {
  color: var(--color-status-resolved);
}
.UserButton[data-current] {
  margin-right: 0;
  border-right: 0.25rem solid var(--color-demo-panel);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: var(--color-demo-panel);
  cursor: default;
}

.Main {
  flex: 1 1 auto;
  background-color: var(--color-demo-panel);
  color: var(--color-demo);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  overflow: auto;
}

.Placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-dim);
}
